export const SET_GALACONTACTS = "SET_GALACONTACTS";
export const SET_CONTACT_LIST = "SET_CONTACT_LIST";
export const SET_CENTER_LIST = "SET_CENTER_LIST";